export enum LanguagesEnum {
  EN = 'en',
  UA = 'uk',
  RU = 'ru'
}
